import { useTheme } from '@emotion/react'
import { Typography } from '../base-ui'
import useBreakpoints from '../../hooks/useBreakpoints'

function EditorTypography({ type, children, ...allProbs }) {
    const breakpoint = useBreakpoints()
    const miniScreen = breakpoint.xs || breakpoint.sm || breakpoint.md
    const theme = useTheme()
    const style = `
        a {
            color : ${theme.colors.secondaryLight};
        }
        img {
            width: auto !important;
            height: auto !important;
            object-fit: contain;
        }
        table {
            width: auto !important;
            height: auto !important;
        }
        ${
            miniScreen &&
            `img {
                max-width: 100% !important;
            }
            table {
                width: 100% !important;
            }`
        }
    `
    const typoSwitch = (hType) => {
        switch (hType) {
            case 'h1':
                return (
                    <Typography
                        className="dynamic-content "
                        type="div"
                        fontSize={theme.typography.h1.fontSize}
                        lineHeight={theme.typography.h1.lineHeight}
                        fontWeight={theme.typography.h1.fontWeight}
                        style={style}
                        {...allProbs}
                    >
                        {children}
                    </Typography>
                )
            case 'h2':
                return (
                    <Typography
                        className="dynamic-content "
                        type="div"
                        fontSize={theme.typography.h2.fontSize}
                        lineHeight={theme.typography.h2.lineHeight}
                        fontWeight={theme.typography.h2.fontWeight}
                        style={style}
                        {...allProbs}
                    >
                        {children}
                    </Typography>
                )
            case 'h3':
                return (
                    <Typography
                        className="dynamic-content "
                        type="div"
                        fontSize={theme.typography.h3.fontSize}
                        lineHeight={theme.typography.h3.lineHeight}
                        fontWeight={theme.typography.h3.fontWeight}
                        style={style}
                        {...allProbs}
                    >
                        {children}
                    </Typography>
                )
            case 'h4':
                return (
                    <Typography
                        className="dynamic-content "
                        type="div"
                        fontSize={theme.typography.h4.fontSize}
                        lineHeight={theme.typography.h4.lineHeight}
                        fontWeight={theme.typography.h4.fontWeight}
                        style={style}
                        {...allProbs}
                    >
                        {children}
                    </Typography>
                )
            case 'h5':
                return (
                    <Typography
                        className="dynamic-content "
                        type="div"
                        fontSize={theme.typography.h5.fontSize}
                        lineHeight={theme.typography.h5.lineHeight}
                        fontWeight={theme.typography.h5.fontWeight}
                        style={style}
                        {...allProbs}
                    >
                        {children}
                    </Typography>
                )
            case 'h6':
                return (
                    <Typography
                        className="dynamic-content "
                        type="div"
                        fontSize={theme.typography.h6.fontSize}
                        lineHeight={theme.typography.h6.lineHeight}
                        fontWeight={theme.typography.h6.fontWeight}
                        style={style}
                        {...allProbs}
                    >
                        {children}
                    </Typography>
                )
            case 'p':
                return (
                    <Typography
                        className="dynamic-content "
                        type="div"
                        fontSize={theme.typography.p.fontSize}
                        lineHeight={theme.typography.p.lineHeight}
                        fontWeight={theme.typography.p.fontWeight}
                        style={style}
                        {...allProbs}
                    >
                        {children}
                    </Typography>
                )
            case 't':
                return (
                    <Typography
                        className="dynamic-content "
                        type="div"
                        fontSize={theme.typography.t.fontSize}
                        lineHeight={theme.typography.t.lineHeight}
                        fontWeight={theme.typography.t.fontWeight}
                        style={style}
                        {...allProbs}
                    >
                        {children}
                    </Typography>
                )
            case 'div':
                return (
                    <Typography
                        className="dynamic-content "
                        type="div"
                        fontSize={theme.typography.div.fontSize}
                        lineHeight={theme.typography.div.lineHeight}
                        fontWeight={theme.typography.div.fontWeight}
                        style={style}
                        {...allProbs}
                    >
                        {children}
                    </Typography>
                )
        }
    }
    return typoSwitch(type)
}

export default EditorTypography
